import { useState } from 'preact/hooks';
import { t } from '../i18n/index.js';
import { GameIcon } from './GameIcon.js';
import { formatDuration, type ArenaState } from '../arena/useArena.js';
import type { ArenaSocket } from '../realtime.js';
import type { ArenaResult } from '../../shared/protocol.js';

/**
 * "Starting soon" in the lobby (decision 2026-09-27): open game tables of multiplayer games
 * with a join button. Joining opens the table page.
 */
export function TablesStrip(props: { socket: ArenaSocket; arena: ArenaState; serverNow: number; canJoin: boolean }) {
  const { arena, serverNow } = props;
  const [error, setError] = useState<string | null>(null);
  const myTable = arena.me?.table ?? null;
  if (arena.tables.length === 0) return null;

  const join = (id: string) =>
    props.socket.emit('table:join', { id }, (r: ArenaResult) => {
      if (r.ok) location.hash = '#/tables';
      else setError(t.arena.errors[r.error]);
    });

  return (
    <section class="tables-strip" aria-label={t.tables.starting}>
      <span class="tables-strip-label">🎲 {t.tables.starting}</span>
      <ul>
        {arena.tables.slice(0, 4).map((tb) => {
          const full = tb.seats.length >= tb.maxPlayers;
          const mine = myTable?.id === tb.id;
          return (
            <li class={`strip-table ${mine ? 'mine' : ''}`}>
              <GameIcon game={tb.gameType} size={24} />
              <span class="strip-text">
                <strong>{t.games[tb.gameType].name}</strong> · {tb.host.displayName} · {t.tables.seats(tb.seats.length, tb.maxPlayers)}
                {tb.startsAt && <> · {t.tables.startsIn(formatDuration(tb.startsAt - serverNow))}</>}
              </span>
              {mine ? (
                <a class="btn btn-small" href="#/tables">
                  {t.tables.title}
                </a>
              ) : (
                <button class="btn btn-primary btn-small" disabled={full || !props.canJoin || Boolean(myTable)} onClick={() => join(tb.id)}>
                  {full ? t.tables.full : t.tables.join}
                </button>
              )}
            </li>
          );
        })}
      </ul>
      {error && <p class="error">{error}</p>}
    </section>
  );
}
